// SALWAR MAHAL: keeps the vertical thumbnail strip in step with the main image on desktop (Oct 2026)
(function () {
  const desktop = window.matchMedia('(min-width: 990px)');

  function setUp() {
    document.querySelectorAll('.product--thumbnail_slider media-gallery').forEach((gallery) => {
      const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
      const list = gallery.querySelector('.thumbnail-list');
      if (!viewer || !list) return;

      // The arrows sit on the main image, not on the whole column
      const wrapper = gallery.closest('.product__media-wrapper');
      if (wrapper && desktop.matches) {
        wrapper.querySelectorAll(':scope > .product-gallery-nav').forEach((btn) => viewer.appendChild(btn));
      }

      // Bring the active thumbnail into view when the arrows or a variant change the image
      const follow = () => {
        if (!desktop.matches) return;
        const active = list.querySelector('.thumbnail[aria-current]:not([aria-current="false"])');
        if (!active) return;
        const item = active.closest('.thumbnail-list__item');
        const top = item.offsetTop;
        const bottom = top + item.offsetHeight;
        if (top < list.scrollTop || bottom > list.scrollTop + list.clientHeight) {
          list.scrollTo({ top: top - 4, behavior: 'smooth' });
        }
      };
      new MutationObserver(follow).observe(list, { attributes: true, subtree: true, attributeFilter: ['aria-current'] });
    });
  }

  // The arrows are created on DOMContentLoaded by product-media-gallery.liquid, so run after that
  if (document.readyState === 'complete') setUp();
  else document.addEventListener('DOMContentLoaded', setUp);
})();
